export enum PowerInputType {
  GRID = 'grid',
  GENERATOR = 'generator',
  SOLAR = 'solar',
  LOAD = 'load',
  ENERGY_METER = 'energyMeter',
}

export enum PowerInputStatus {
  ACTIVE = 'active',
  BUSY = 'busy',
  ERROR = 'error',
  IDLE = 'idle',
  UNKNOWN = 'unknown',
}

export type PowerInputDetail = {
  label: string;
  value: string | number | null | undefined;
  showStatusDot?: boolean;
  dotColor?: string;
};

export type PowerInput = {
  id?: string | number;
  name: string;
  type: PowerInputType;
  status?: PowerInputStatus;
  isEnergized?: boolean;
  details?: PowerInputDetail[];
};

export const isPowerInputActive = (status?: PowerInputStatus): boolean => status === PowerInputStatus.ACTIVE;
